module.exports = __webpack_public_path__ + "img/trelos1.021698ff.png";